
















import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import providers from "@/lib/api";
import { $t } from "@/lib/i18nHelpers";
import { format, getNow, parse } from "@/lib/time";
import { FormFields, FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import BaseForm from "@/components/BaseForm";

export default defineComponent({
  name: "SchedulePostSettings",
  components: { BaseForm, BaseButton },
  props: {
    postData: { type: Object as PropType<ContentSet>, required: true },
  },
  setup(props, { emit }) {
    const values = ref<FormValues>({});
    const fields = computed<FormFields>(() => {
      return [
        {
          name: "date",
          label: $t("Date"),
          type: "date",
        },
        {
          name: "time",
          label: $t("Time"),
          type: "time",
        },
      ];
    });

    const date = computed<Date>(() =>
      parse(
        `${values.value.date ?? format(getNow(), "yyyy-MM-dd")} ${values.value.time ?? format(getNow(), "HH:mm")}`,
        "yyyy-MM-dd HH:mm",
        getNow()
      )
    );

    const updateScheduleTime = async () => {
      if (!props.postData.scheduleTime && date.value.getTime() <= getNow().getTime()) return;
      await providers.ContentSetProvider.update({
        data: {
          id: props.postData.id,
          scheduleTime: date.value.toISOString(),
        },
      });
    };

    const onSetTime = (date = getNow()) => {
      values.value = {
        date: format(date, "yyyy-MM-dd"),
        time: format(date, "HH:mm"),
      };
    };
    const onReset = () => {
      values.value = {};
    };

    const isFutureScheduleTime = computed(() => {
      return props.postData.scheduleTime && new Date(props.postData.scheduleTime).getTime() > getNow().getTime();
    });

    isFutureScheduleTime.value && onSetTime(new Date(props.postData.scheduleTime ?? "") || undefined);

    emit("setUpdateCb", updateScheduleTime);

    return { fields, values, date, onReset };
  },
});
